module.exports = __webpack_public_path__ + "img/pasqualebruni_0.2ab01977.jpg";